


import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useOutletContext } from "react-router-dom";
import { db, auth } from "./firebase";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { collection, addDoc, serverTimestamp, query, where, getDocs, doc, getDoc, updateDoc, onSnapshot } from "firebase/firestore";
// IMPORT THE NEW PAYMENT SERVICE
import { processPayment } from "./PaymentService";
import TermsPage from "./TermsPage";
import PrivacyPage from "./PrivacyPage";
import "./therapist.css";

// --- ASSET PATHS ---
const ASSETS = {
    hero: "/Nabi UI Assets/Assets_Images/Image_Schedule Session hero image.png",
    razorpay: "/Nabi UI Assets/Assets_Images/Image_Logo Razorpay.png",
    videoPlaceholder: "/Nabi UI Assets/Assets_Images/Image_Video placeholder.png",
    playIcon: "/Nabi UI Assets/Assets_Icon/Icon_Play circle.svg",
    icons: {
        intake: "/Nabi UI Assets/Assets_Icon/Icon_Intake Form.svg",
        schedule: "/Nabi UI Assets/Assets_Icon/Icon_Schedule Booking.svg",
        payment: "/Nabi UI Assets/Assets_Icon/Icon_Payment.svg",
        edit: "/Nabi UI Assets/Assets_Icon/Icon_Edit.svg",
        check: "/Nabi UI Assets/Assets_Icon/Icon_Check circle filled.svg",
        arrowDown: "/Nabi UI Assets/Assets_Icon/Icon_Arrow down.svg",
        close: "/Nabi UI Assets/Assets_Icon/Icon_Close.svg",
        starFilled: "/Nabi UI Assets/Assets_Icon/Icon_Star filled.svg",
        starUnfilled: "/Nabi UI Assets/Assets_Icon/Icon_Star unfilled.svg",
    }
};

// --- HELPER: Get Day Name ---
const getDayName = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { weekday: 'long' });
};

const getInitials = (name) => {
  if (!name) return "TP";
  const parts = name.split(" ");
  if (parts.length > 1) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

const customCSS = `
  /* Input Field Styling */
  .custom-calendar-input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    borderRadius: 8px;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    outline: none;
  }

  /* Header Layout (Double Arrows + Title) */
  .custom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    background: white;
  }
  .header-title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  .nav-buttons button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 18px;
    color: #333;
    margin: 0 5px;
  }

  /* Calendar Body */
  .react-datepicker {
    border: 1px solid #eee;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    font-family: 'Inter', sans-serif;
  }
  .react-datepicker__day-name { color: #333; font-weight: 500; width: 2.5rem; }
  .react-datepicker__day { width: 2.5rem; line-height: 2.5rem; color: #444; }

  /* Muted dates from other months */
  .react-datepicker__day--outside-month {
    color: #ccc !important;
  }

  /* Selected Date (Lighter shade) */
  .react-datepicker__day--selected {
    background-color: #f5c3b7 !important;
    color: white !important;
    border-radius: 4px;
  }

  /* Prevent default keyboard-selection from confusing users */
  .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected) {
    background-color: transparent !important;
    color: inherit !important;
  }

  /* Available Slots Highlight (Darker shade) */
  .react-datepicker__day--has-availability {
    background-color: #ec786d !important;
    color: #ffffff !important;
    font-weight: bold !important;
    border-radius: 4px;
  }

  /* Keep selected state prioritized */
  .react-datepicker__day--has-availability.react-datepicker__day--selected,
  .react-datepicker__day--has-bookings.react-datepicker__day--selected,
  .react-datepicker__day--has-availability.react-datepicker__day--has-bookings.react-datepicker__day--selected {
    background-color: #f5c3b7 !important;
    color: white !important;
  }

  /* Today Footer Button */
  .today-button-container {
    border-top: 1px solid #eee;
    text-align: center;
    padding: 10px 0;
  }
  .today-btn {
    color: #F07167;
    background: none;
    border: none;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    width: 100%;
  }

  /* Custom Checkbox */
  .custom-checkbox {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #767676;
    border-radius: 3px;
    outline: none;
    cursor: pointer;
    background-color: white;
    margin: 0;
    display: inline-block;
    vertical-align: middle;
  }

  .custom-checkbox:checked {
    background-color: #f17167;
    border-color: #f17167;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
    background-size: 80%;
    background-position: center;
    background-repeat: no-repeat;
  }
`;


// --- SUB-COMPONENTS ---

const IntakeForm = ({ formData, handleInput, nextStep, onBack, onOpenTerms, onOpenPrivacy, onAuthCheck }) => {
    const isValid =
        formData.fullName &&
        formData.age &&
        formData.gender &&
        formData.contactNumber &&
        formData.email &&
        formData.trustName &&
        formData.trustRelationship &&
        formData.trustContact &&
        formData.declaration1 &&
        formData.declaration2 &&
        formData.declaration3 &&
        formData.termsAccepted;

    const handleAuthIntercept = (e) => {
        if (!auth.currentUser) {
            if (e && e.preventDefault) e.preventDefault();
            alert("Please login to book a slot.");
            if (onAuthCheck) onAuthCheck();
            return false;
        }
        return true;
    };

    return (
        <div className="booking-card-content" style={styles.cardContent}>
            <p style={styles.formNote}>Please fill in the details to help us know you better!</p>

            <div className="booking-form-row" style={styles.row}>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Full Name<span style={styles.red}>*</span></label>
                    <input 
                        style={styles.input} 
                        placeholder="Enter full name here" 
                        value={formData.fullName} 
                        onClick={e => handleAuthIntercept(e)}
                        onChange={e => {
                            if (handleAuthIntercept(e)) {
                                handleInput("fullName", e.target.value);
                            }
                        }} 
                    />
                </div>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Age<span style={styles.red}>*</span></label>
                    <input 
                        style={styles.input} 
                        placeholder="Enter your age" 
                        value={formData.age} 
                        onClick={e => handleAuthIntercept(e)}
                        onChange={e => {
                            if (handleAuthIntercept(e)) {
                                handleInput("age", e.target.value);
                            }
                        }} 
                    />
                </div>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Gender<span style={styles.red}>*</span></label>
                    <select 
                        style={styles.select} 
                        value={formData.gender} 
                        onClick={e => handleAuthIntercept(e)}
                        onChange={e => {
                            if (handleAuthIntercept(e)) {
                                handleInput("gender", e.target.value);
                            }
                        }}
                    >
                        <option value="">Select</option><option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option>
                    </select>
                </div>
            </div>

            <div className="booking-form-row" style={styles.row}>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Contact Number<span style={styles.red}>*</span></label>
                    <div className="booking-phone-group" style={{ display: 'flex', gap: '10px' }}>
                        <select style={{ ...styles.select, width: '80px' }}><option>+91</option></select>
                        <input
                            style={styles.input}
                            placeholder="Enter phone number"
                            value={formData.contactNumber}
                            onClick={e => handleAuthIntercept(e)}
                            onChange={e => {
                                if (handleAuthIntercept(e)) {
                                    const numericValue = e.target.value.replace(/\D/g, "").slice(0, 10);
                                    handleInput("contactNumber", numericValue);
                                }
                            }}
                        />
                        {formData.contactNumber && formData.contactNumber.length !== 10 && (
                            <span style={{ color: '#ff4444', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                Please enter exactly 10 digits
                            </span>
                        )}
                    </div>
                </div>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Email<span style={styles.red}>*</span></label>
                    <input 
                        style={styles.input} 
                        placeholder="Enter your email" 
                        value={formData.email} 
                        onClick={e => handleAuthIntercept(e)}
                        onChange={e => {
                            if (handleAuthIntercept(e)) {
                                handleInput("email", e.target.value);
                            }
                        }} 
                    />
                </div>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>I am a...<span style={styles.red}>*</span></label>
                    <select 
                        style={styles.select} 
                        value={formData.studentStatus} 
                        onClick={e => handleAuthIntercept(e)}
                        onChange={e => {
                            if (handleAuthIntercept(e)) {
                                handleInput("studentStatus", e.target.value);
                            }
                        }}
                    >
                        <option value="Student">Student</option><option value="Other">Other</option>
                    </select>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '30px', marginBottom: '15px' }}>
                <h4 style={{ margin: 0, color: '#333' }}>The person I trust</h4>
                <span style={{ fontSize: '14px', cursor: 'pointer' }}>ⓘ</span>
            </div>

            <div className="booking-form-row" style={styles.row}>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Contact Name<span style={styles.red}>*</span></label>
                    <input 
                        style={styles.input} 
                        placeholder="Enter full name here" 
                        value={formData.trustName} 
                        onClick={e => handleAuthIntercept(e)}
                        onChange={e => {
                            if (handleAuthIntercept(e)) {
                                handleInput("trustName", e.target.value);
                            }
                        }} 
                    />
                </div>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Relationship<span style={styles.red}>*</span></label>
                    <select 
                        style={styles.select} 
                        value={formData.trustRelationship} 
                        onClick={e => handleAuthIntercept(e)}
                        onChange={e => {
                            if (handleAuthIntercept(e)) {
                                handleInput("trustRelationship", e.target.value);
                            }
                        }}
                    >
                        <option value="">Select</option><option value="Parent">Parent</option><option value="Sibling">Sibling</option><option value="Friend">Friend</option>
                    </select>
                </div>
                <div style={styles.inputGroup}>
                    <label style={styles.label}>Contact Number<span style={styles.red}>*</span></label>
                    <div className="booking-phone-group" style={{ display: 'flex', gap: '10px' }}>
                        <select style={{ ...styles.select, width: '80px' }}><option>+91</option></select>
                        <input
                            style={styles.input}
                            placeholder="Enter phone number"
                            value={formData.trustContact} 
                            onClick={e => handleAuthIntercept(e)}
                            onChange={e => {
                                if (handleAuthIntercept(e)) {
                                    const numericValue = e.target.value.replace(/\D/g, "").slice(0, 10);
                                    handleInput("trustContact", numericValue);
                                }
                            }}
                        />
                        {formData.trustContact && formData.trustContact.length !== 10 && (
                            <span style={{ color: '#ff4444', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                Please enter exactly 10 digits
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <h4 style={{ marginTop: '30px', marginBottom: '15px', color: '#333' }}>Declaration</h4>
            <div style={styles.checkboxGroup}>
                <label style={styles.checkLabel}>
                    <input type="checkbox" className="custom-checkbox" checked={formData.declaration1} onChange={e => handleInput("declaration1", e.target.checked)} />
                    Firm is not responsible for the actions of the individual during (or) past therapy session.
                </label>
                <label style={styles.checkLabel}>
                    <input type="checkbox" className="custom-checkbox" checked={formData.declaration2} onChange={e => handleInput("declaration2", e.target.checked)} />
                    Information about lapsing time period of package booking.
                </label>
                <label style={styles.checkLabel}>
                    <input type="checkbox" className="custom-checkbox" checked={formData.declaration3} onChange={e => handleInput("declaration3", e.target.checked)} />
                    Any etiquettes and waiting period before therapy sessions lapse.
                </label>
                <label style={styles.checkLabel}>
                    <input
                        type="checkbox"
                        className="custom-checkbox"
                        checked={formData.termsAccepted}
                        onChange={e => handleInput("termsAccepted", e.target.checked)}
                    />
                    <span>
                        I accept the{" "}
                        <span
                            onClick={onOpenTerms}
                            style={{ color: '#333', textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                        >
                            terms and conditions
                        </span>{" "}
                        and{" "}
                        <span
                            onClick={onOpenPrivacy}
                            style={{ color: '#333', textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                        >
                            privacy policy
                        </span>.
                    </span>
                </label>
            </div>

            <div className="booking-button-row" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
                <button onClick={onBack} style={styles.backBtn}>Back</button>
                <button
                    onClick={isValid ? nextStep : null}
                    style={isValid ? styles.continueBtnActive : styles.continueBtn}
                    disabled={!isValid}
                >
                    Submit & Continue
                </button>
            </div>
        </div>
    );
};

// const ScheduleForm = ({ formData, handleInput, prevStep, nextStep, therapist, price, user, packageType }) => {

//     const todayStr = new Date().toISOString().split('T')[0];

//     const onDateChange = (date) => {
//         if (!date) return;
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         const dateString = `${year}-${month}-${day}`;
//         handleInput("date", dateString);
//     };
//     const headerBtnStyle = { border: 'none', background: 'none', cursor: 'pointer', fontSize: '16px', padding: '0 5px' };
//     const [availableSlots, setAvailableSlots] = useState([]);
//     const [loadingSlots, setLoadingSlots] = useState(false);
//     const [availabilityMessage, setAvailabilityMessage] = useState("");
//     const [therapistSchedule, setTherapistSchedule] = useState(null);

//     // --- FETCH FULL SCHEDULE UPFRONT ---
//     useEffect(() => {
//         const fetchSchedule = async () => {
//             if (!therapist) return;
//             try {
//                 console.log("Fetching availability for therapist:", therapist.name, "ID:", therapist.id, "Email:", therapist.email);

//                 const allSnap = await getDocs(collection(db, "therapist_availability"));
//                 const allDocs = allSnap.docs.map(d => ({ docId: d.id, ...d.data() }));

//                 // Find ALL potential matches (by ID, email, or name)
//                 const matchedDocs = allDocs.filter(d => {
//                     const isIdMatch = d.docId === therapist.id;
//                     const tEmail = therapist.email?.toLowerCase().trim();
//                     const dEmail = d.email?.toLowerCase().trim();
//                     const tName = therapist.name?.toLowerCase().trim();
//                     const dName = d.name?.toLowerCase().trim();
//                     const dTherapistName = d.therapistName?.toLowerCase().trim();

//                     return isIdMatch ||
//                         (tEmail && dEmail === tEmail) ||
//                         (tName && dName === tName) ||
//                         (tName && dTherapistName === tName);
//                 });

//                 // Sort so that documents with populated monthlySlots come first. 
//                 // This defeats stray "test" documents that might have the matching ID but no real data.
//                 matchedDocs.sort((a, b) => {
//                     const aHasSlots = a.monthlySlots && Object.keys(a.monthlySlots).length > 0 ? 1 : 0;
//                     const bHasSlots = b.monthlySlots && Object.keys(b.monthlySlots).length > 0 ? 1 : 0;
//                     return bHasSlots - aHasSlots;
//                 });

//                 let matchedData = matchedDocs.length > 0 ? matchedDocs[0] : null;

//                 if (matchedData) {
//                     console.log("Successfully matched availability document. DocId:", matchedData.docId);
//                     setTherapistSchedule(matchedData);
//                 } else {
//                       }
//                     }
//                     console.warn("Therapist availability not found for:", therapist.name);
//                     setTherapistSchedule({});
//                 }

//             } catch (error) {
//                 console.error("Error fetching schedule:", error);
//                 setTherapistSchedule({});
//             }
//         };
//         fetchSchedule();
//     }, [therapist]);

//     const filterAvailableDates = (date) => {
//         if (!therapistSchedule || !therapistSchedule.monthlySlots) return false;

//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         const dateStr = `${year}-${month}-${day}`;

//         const slotsForDate = therapistSchedule.monthlySlots[dateStr];
//         return Array.isArray(slotsForDate) && slotsForDate.length > 0;
//     };


//     // --- FETCH SLOTS DYNAMICALLY ---
//     useEffect(() => {
//         const fetchAvailability = async () => {
//             if (!formData.date || !therapistSchedule) {
//                 setAvailableSlots([]);
//                 return;
//             }

//             setLoadingSlots(true);
//             setAvailabilityMessage("Checking availability...");
//             setAvailableSlots([]);

//             let finalSlots = [];
//             let daySlots = [];
//             let bookedTimeSlots = [];

//             try {
//                 // Get slots for this date from the pre-fetched monthlySlots
//                 const availableDates = therapistSchedule.monthlySlots ? Object.keys(therapistSchedule.monthlySlots) : [];
//                 console.log("Selected Date:", formData.date, "Available Date Keys in DB:", availableDates);

//                 const daySlotsData = therapistSchedule.monthlySlots?.[formData.date] || [];

//                 // Store just the "From" time so that the Cloud Function can successfully parse the Date object
//                 daySlots = daySlotsData.map(slot => slot.from);

//                 const bookingsRef = collection(db, "bookings");
//                 const q = query(
//                     bookingsRef,
//                     where("therapistId", "==", therapist?.id),
//                     where("date", "==", formData.date)
//                 );

//                 const querySnapshot = await getDocs(q);
//                 bookedTimeSlots = querySnapshot.docs.map(doc => doc.data().timeSlot);

//                 // Filter out slots that are already booked
//                 finalSlots = daySlots.filter(slot => !bookedTimeSlots.includes(slot));

//             } catch (error) {
//                 console.error("Firestore Error: ", error);
//                 finalSlots = [];
//             } finally {
//                 // Final state update regardless of try/catch outcome
//                 console.log("DaySlots found:", daySlots.length, "BookedSlots found:", bookedTimeSlots.length, "FinalSlots:", finalSlots.length);

//                 if (daySlots.length === 0) {
//                     setAvailabilityMessage("No availability configured for this therapist on this date.");
//                     setAvailableSlots([]);
//                 } else if (finalSlots.length === 0) {
//                     setAvailabilityMessage("All slots for this date are already booked.");
//                     setAvailableSlots([]);
//                 } else {
//                     setAvailabilityMessage("");
//                     setAvailableSlots(finalSlots);
//                 }
//                 setLoadingSlots(false);
//             }
//         };

//         fetchAvailability();
//     }, [formData.date, therapistSchedule, therapist]);

//     return (
//         <div style={styles.cardContent}>
//             <div style={styles.bookingDetailsHeader}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                     <span style={{ fontSize: '16px', fontWeight: 'bold' }}>Booking Details</span>
//                     <span style={{ fontSize: '12px', color: '#555', cursor: 'pointer' }}>✎ Edit</span>
//                 </div>
//                 <img src={ASSETS.icons.arrowDown} style={{ width: '12px', transform: 'rotate(180deg)', cursor: 'pointer' }} alt="^" />
//             </div>
//             <div style={styles.bookingSummaryRow}>
//                 <span style={styles.summaryItem}>{packageType || "One Session Package"}</span> <span style={styles.pipe}>|</span>
//                 <span style={styles.summaryItem}> {therapist.location}</span> <span style={styles.pipe}>|</span>
//                 <span style={styles.summaryItem}> {therapist.name}</span> <span style={styles.pipe}>|</span>
//                 <span style={styles.summaryItem}> Duration: 60 mins</span> <span style={styles.pipe}>|</span>
//                 <span style={styles.badgeDark}>Available online</span>
//                 <span style={{ marginLeft: 'auto', fontSize: '14px' }}>Total Amount : <strong>₹{price}</strong></span>
//             </div>

//             <h3 style={{ fontSize: '14px', color: '#555', margin: '30px 0 20px' }}>Schedule Your Service ⓘ</h3>

//             {/* Temporary Debug Info */}
//             {/* <div style={{ fontSize: '11px', color: '#888', marginBottom: '10px', background: '#eee', padding: '5px' }}>
//                 DEBUG - Selected Date: {formData.date || 'none'} <br/>
//                 DB Keys Found: {therapistSchedule?.monthlySlots ? Object.keys(therapistSchedule.monthlySlots).join(', ') : 'none'} <br/>
//                 Looking for Therapist: {therapist?.name} / {therapist?.email} <br/>
//                 Matched Therapist Doc: {therapistSchedule?.docId || 'none'} ({therapistSchedule?.email || 'no email'})
//             </div> */}

//             <div style={{ display: 'flex', gap: '40px', flexWrap: 'wrap' }}>

//                 <div style={{ flex: 1, minWidth: '250px' }}>
//                     <style>{customCSS}</style>
//                     <label style={styles.label}>Select Date<span style={styles.red}>*</span></label>
//                     <DatePicker
//                         selected={formData.date ? new Date(formData.date) : null}
//                         onChange={onDateChange}
//                         dateFormat="yyyy-MM-dd"
//                         placeholderText="Click to select a date"

//                         // 2. DISALLOW PREVIOUS DATES (Validation)
//                         minDate={new Date()}

//                         // Matches your existing input styling
//                         customInput={
//                             <input style={styles.dateInput} />
//                         }

//                         renderCustomHeader={({
//                             date,
//                             decreaseMonth,
//                             increaseMonth,
//                             prevMonthButtonDisabled,
//                             nextMonthButtonDisabled,
//                             decreaseYear,
//                             increaseYear
//                         }) => (
//                             <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', alignItems: 'center' }}>
//                                 <div>
//                                     <button type="button" onClick={decreaseYear} style={headerBtnStyle}>{"<<"}</button>
//                                     <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={headerBtnStyle}>{"<"}</button>
//                                 </div>

//                                 <span style={{ fontWeight: '600', fontSize: '14px' }}>
//                                     {date.toLocaleString('default', { month: 'short' })} {date.getFullYear()}
//                                 </span>

//                                 <div>
//                                     <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={headerBtnStyle}>{">"}</button>
//                                     <button type="button" onClick={increaseYear} style={headerBtnStyle}>{">>"}</button>
//                                 </div>
//                             </div>
//                         )}
//                     >
//                         {/* 3. CONDITIONAL TODAY BUTTON: Only shows if the selected date is Today */}
//                         {formData.date === todayStr && (
//                             <div style={{ borderTop: '1px solid #eee', textAlign: 'center', padding: '10px' }}>
//                                 <button
//                                     type="button"
//                                     style={{ color: '#F07167', background: 'none', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}
//                                     onClick={() => onDateChange(new Date())}
//                                 >
//                                     Today
//                                 </button>
//                             </div>
//                         )}
//                     </DatePicker>    {/* <input type="date" style={styles.dateInput} value={formData.date} onChange={e => handleInput("date", e.target.value)} /> */}
//                 </div>
//                 <div style={{ flex: 2, minWidth: '300px' }}>
//                     <label style={styles.label}>
//                         {formData.date ? `Available Time Slots for ${getDayName(formData.date)}` : "Select a date to see slots"}
//                     </label>

//                     {loadingSlots ? (
//                         <p style={{ fontSize: '13px', color: '#666' }}>Loading available slots...</p>
//                     ) : (
//                         <>
//                             {availableSlots.length > 0 ? (
//                                 <div style={styles.timeSlots}>
//                                     {availableSlots.map(slot => (
//                                         <button
//                                             key={slot}
//                                             onClick={() => handleInput("timeSlot", slot)}
//                                             style={formData.timeSlot === slot ? styles.timePillActive : styles.timePill}
//                                         >
//                                             <span style={{ marginRight: '5px' }}>🕒</span> {slot}
//                                         </button>
//                                     ))}
//                                 </div>
//                             ) : (
//                                 <p style={{ fontSize: '13px', color: '#F07167' }}>{availabilityMessage || "Please select a date."}</p>
//                             )}
//                         </>
//                     )}
//                 </div>
//             </div>

//             <div style={{ marginTop: '30px' }}>
//                 <label style={styles.label}>Add your message (Optional)</label>
//                 <textarea
//                     style={styles.textArea}
//                     placeholder="Enter your message"
//                     value={formData.message}
//                     onChange={e => handleInput("message", e.target.value)}
//                 />
//                 <p style={{ fontSize: '10px', color: '#888', marginTop: '5px' }}>0 of 300 characters left</p>
//             </div>

//             <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
//                 <button onClick={prevStep} style={styles.backBtn}>Go Back to Previous Step</button>
//                 <button
//                     onClick={nextStep}
//                     style={formData.date && formData.timeSlot ? styles.continueBtnActive : styles.continueBtn}
//                     disabled={!formData.date || !formData.timeSlot}
//                 >
//                     Continue
//                 </button>
//             </div>
//         </div>
//     );
// };

const ScheduleForm = ({ formData, handleInput, prevStep, nextStep, therapist, price, user, packageType }) => {

    const todayStr = new Date().toISOString().split('T')[0];

    // Function to check slot availability status
    const getSlotStatus = (startTime, selectedDateStr) => {
        if (!startTime || !selectedDateStr) return 'available';

        const now = new Date();
        const selectedDate = new Date(selectedDateStr);

        // Only check if the selected date is TODAY
        if (selectedDate.toDateString() === now.toDateString()) {
            // Parse the start time (format like "2:00 PM")
            const [time, modifier] = startTime.trim().split(' ');
            let [hours, minutes] = time.split(':');

            // Convert to 24-hour format
            let hour24 = parseInt(hours);
            if (modifier && modifier.toUpperCase() === 'PM' && hour24 !== 12) hour24 += 12;
            if (modifier && modifier.toUpperCase() === 'AM' && hour24 === 12) hour24 = 0;

            // Create date object for the slot start time
            const slotDateTime = new Date(selectedDateStr);
            slotDateTime.setHours(hour24, parseInt(minutes), 0, 0);

            let bufferTime = 7 * 60 * 60 * 1000; // 7 hours in ms

            if (slotDateTime < now) {
                return 'passed';
            } else if (slotDateTime.getTime() - now.getTime() < bufferTime) {
                return 'soon';
            }
        }

        return 'available';
    };

    // Updated onDateChange to clear timeSlot when date changes
    const onDateChange = (date) => {
        if (!date) return;

        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const selectedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

        // Prevent selecting past dates
        if (selectedDate < today) {
            alert("Please select today's date or a future date. Past dates cannot be booked.");
            return;
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        handleInput("date", dateString);
        handleInput("timeSlot", ""); // Clear previously selected time slot
    };

    const headerBtnStyle = { border: 'none', background: 'none', cursor: 'pointer', fontSize: '16px', padding: '0 5px' };
    const [availableSlots, setAvailableSlots] = useState([]);
    const [loadingSlots, setLoadingSlots] = useState(false);
    const [availabilityMessage, setAvailabilityMessage] = useState("");
    const [therapistSchedule, setTherapistSchedule] = useState(null);

    // --- FETCH FULL SCHEDULE UPFRONT ---
    useEffect(() => {
        const fetchSchedule = async () => {
            if (!therapist) return;
            try {
                console.log("Fetching availability for therapist:", therapist.name);

                const allSnap = await getDocs(collection(db, "therapist_availability"));
                const allDocs = allSnap.docs.map(d => ({ docId: d.id, ...d.data() }));

                const matchedDocs = allDocs.filter(d => {
                    const isIdMatch = d.docId === therapist.id;
                    const tEmail = therapist.email?.toLowerCase().trim();
                    const dEmail = d.email?.toLowerCase().trim();
                    const tName = therapist.name?.toLowerCase().trim();
                    const dName = d.name?.toLowerCase().trim();
                    const dTherapistName = d.therapistName?.toLowerCase().trim();

                    return isIdMatch ||
                        (tEmail && dEmail === tEmail) ||
                        (tName && dName === tName) ||
                        (tName && dTherapistName === tName);
                });

                matchedDocs.sort((a, b) => {
                    const aHasSlots = a.monthlySlots && Object.keys(a.monthlySlots).length > 0 ? 1 : 0;
                    const bHasSlots = b.monthlySlots && Object.keys(b.monthlySlots).length > 0 ? 1 : 0;
                    return bHasSlots - aHasSlots;
                });

                let matchedData = matchedDocs.length > 0 ? matchedDocs[0] : null;

                if (matchedData) {
                    console.log("Successfully matched availability document");
                    setTherapistSchedule(matchedData);
                } else {
                    console.warn("Therapist availability not found for:", therapist.name);
                    setTherapistSchedule({});
                }

            } catch (error) {
                console.error("Error fetching schedule:", error);
                setTherapistSchedule({});
            }
        };
        fetchSchedule();
    }, [therapist]);

    const [bookedDates, setBookedDates] = useState({});

    // --- FETCH ALL BOOKINGS UPFRONT FOR CALENDAR HIGHLIGHTS ---
    useEffect(() => {
        const fetchAllBookings = async () => {
            if (!therapist?.id) return;
            try {
                const bookingsRef = collection(db, "bookings");
                const q = query(bookingsRef, where("therapistId", "==", therapist.id));
                const querySnapshot = await getDocs(q);
                
                let bDates = {};
                querySnapshot.docs.forEach(doc => {
                    const data = doc.data();
                    if (data.status === "cancelled" || data.status === "payment_failed" || data.paymentStatus === "failed") return;

                    // Free up abandoned pending bookings (older than 15 mins)
                    if (data.status === "pending_verification" || data.status === "processing_payment") {
                        if (data.createdAt && typeof data.createdAt.toMillis === 'function') {
                            const ageInMinutes = (Date.now() - data.createdAt.toMillis()) / (1000 * 60);
                            if (ageInMinutes > 15) return;
                        }
                    }

                    const addBooking = (date, time) => {
                        if (!date || !time) return;
                        if (!bDates[date]) bDates[date] = [];
                        bDates[date].push(time);
                    };

                    addBooking(data.date, data.timeSlot);
                    if (data.session_1) addBooking(data.session_1.date, data.session_1.time);
                    
                    for (let i = 2; i <= 4; i++) {
                        const sess = data[`session_${i}`];
                        if (sess && sess.date) {
                            addBooking(sess.date, sess.time);
                        }
                    }
                });
                setBookedDates(bDates);
            } catch (error) {
                console.error("Error fetching all bookings:", error);
            }
        };
        fetchAllBookings();
    }, [therapist?.id]);

    // --- FETCH SLOTS DYNAMICALLY ---
    useEffect(() => {
        const fetchAvailability = async () => {
            if (!formData.date || !therapistSchedule) {
                setAvailableSlots([]);
                return;
            }

            setLoadingSlots(true);
            setAvailabilityMessage("Checking availability...");
            setAvailableSlots([]);

            let daySlots = [];           // Will store full slot objects {from: "2:00 PM", to: "3:00 PM"}
            let bookedTimeSlots = [];     // Already booked slots as strings

            try {
                // Get full slot objects (with from AND to) from therapist's schedule
                const daySlotsData = therapistSchedule.monthlySlots?.[formData.date] || [];
                daySlots = daySlotsData;  // Store the full slot objects
                console.log("All slots for date:", daySlots);

                // Fetch all bookings for the therapist to check all sessions
                const bookingsRef = collection(db, "bookings");
                const q = query(
                    bookingsRef,
                    where("therapistId", "==", therapist?.id)
                );

                const querySnapshot = await getDocs(q);
                
                bookedTimeSlots = [];
                querySnapshot.docs.forEach(doc => {
                    const data = doc.data();
                    if (data.status === "cancelled" || data.status === "payment_failed" || data.paymentStatus === "failed") return;

                    // Free up abandoned pending bookings (older than 15 mins)
                    if (data.status === "pending_verification" || data.status === "processing_payment") {
                        if (data.createdAt && typeof data.createdAt.toMillis === 'function') {
                            const ageInMinutes = (Date.now() - data.createdAt.toMillis()) / (1000 * 60);
                            if (ageInMinutes > 15) return;
                        }
                    }

                    // Check root date (Session 1)
                    if (data.date === formData.date && data.timeSlot) {
                        bookedTimeSlots.push(data.timeSlot);
                    }
                    if (data.session_1 && data.session_1.date === formData.date && data.session_1.time) {
                        bookedTimeSlots.push(data.session_1.time);
                    }

                    // Check subsequent sessions (2, 3, 4)
                    for (let i = 2; i <= 4; i++) {
                        const sess = data[`session_${i}`];
                        if (sess && sess.date === formData.date && sess.time) {
                            bookedTimeSlots.push(sess.time);
                        }
                    }
                });
                
                console.log("Booked slots:", bookedTimeSlots);

                // Filter slots: NOT booked AND NOT in the past
                const finalSlots = daySlots.map(slot => {
                    // Create formatted time string (e.g., "2:00 PM - 3:00 PM")
                    const formattedTimeSlot = `${slot.from} - ${slot.to}`;

                    // Check if this slot is already booked
                    const isBooked = bookedTimeSlots.includes(formattedTimeSlot);

                    // Check slot status (available, soon, or passed)
                    const status = getSlotStatus(slot.from, formData.date);

                    return { ...slot, isBooked, status };
                }).filter(slot => {
                    // Keep slot only if it's NOT booked AND NOT passed (keep 'soon' and 'available')
                    return !slot.isBooked && slot.status !== 'passed';
                });

                setAvailableSlots(finalSlots);
                console.log("Final available slots:", finalSlots);

                // Set appropriate messages
                if (daySlots.length === 0) {
                    setAvailabilityMessage("No availability configured for this therapist on this date.");
                } else if (finalSlots.length === 0) {
                    if (bookedTimeSlots.length === daySlots.length) {
                        setAvailabilityMessage("All slots for this date are already booked.");
                    } else {
                        setAvailabilityMessage("All available slots for today have passed. Please select a future date.");
                    }
                } else {
                    setAvailabilityMessage("");
                }

            } catch (error) {
                console.error("Firestore Error: ", error);
                setAvailableSlots([]);
                setAvailabilityMessage("Error loading slots. Please try again.");
            } finally {
                setLoadingSlots(false);
            }
        };

        fetchAvailability();
    }, [formData.date, therapistSchedule, therapist]);

    const getDayClassName = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (date < today) {
            return "";
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateStr = `${year}-${month}-${day}`;

        let classes = [];
        
        const daySlots = therapistSchedule?.monthlySlots?.[dateStr] || [];
        const rawBookedSlots = bookedDates[dateStr];
        const bookedSlotsForDay = Array.isArray(rawBookedSlots) ? rawBookedSlots : [];

        let validSlotsCount = 0;
        let allBookedCount = 0;

        daySlots.forEach(slot => {
            const formattedTimeSlot = `${slot.from} - ${slot.to}`;
            const isBooked = bookedSlotsForDay.includes(formattedTimeSlot);
            const status = getSlotStatus(slot.from, dateStr);
            
            if (status !== 'passed') {
                validSlotsCount++;
                if (isBooked) allBookedCount++;
            }
        });

        const hasAvailability = validSlotsCount > 0;
        const allBooked = hasAvailability && (validSlotsCount === allBookedCount);

        if (hasAvailability && !allBooked) {
            classes.push("react-datepicker__day--has-availability");
        }

        return classes.join(" ");
    };

    return (
        <div className="booking-card-content" style={styles.cardContent}>
            <div style={styles.bookingDetailsHeader}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>Booking Details</span>
                    <span style={{ fontSize: '12px', color: '#555', cursor: 'pointer' }}>✎ Edit</span>
                </div>
                <img src={ASSETS.icons.arrowDown} style={{ width: '12px', transform: 'rotate(180deg)', cursor: 'pointer' }} alt="^" />
            </div>
            <div className="booking-summary-row" style={styles.bookingSummaryRow}>
                <span style={styles.summaryItem}>{packageType || "One Session Package"}</span> <span style={styles.pipe}>|</span>
                <span style={styles.summaryItem}> {therapist.location}</span> <span style={styles.pipe}>|</span>
                <span style={styles.summaryItem}> {therapist.name}</span> <span style={styles.pipe}>|</span>
                <span style={styles.summaryItem}> Duration: 60 mins</span> <span style={styles.pipe}>|</span>
                <span style={styles.badgeDark}>Available online</span>
                <span style={{ marginLeft: 'auto', fontSize: '14px' }}>Total Amount : <strong>₹{price}</strong></span>
            </div>

            <h3 style={{ fontSize: '14px', color: '#515151', margin: '30px 0 20px' }}>Schedule Your Service ⓘ</h3>

            <div className="booking-schedule-row" style={{ display: 'flex', gap: '40px', flexWrap: 'wrap' }}>

                <div className="booking-schedule-col" style={{ flex: 1, minWidth: '250px' }}>
                    <label style={styles.label}>Select Date<span style={styles.red}>*</span></label>
                    <DatePicker
                        selected={formData.date ? new Date(formData.date) : null}
                        onChange={onDateChange}
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Click to select a date"
                        minDate={new Date()}
                        customInput={<input style={styles.dateInput} />}
                        dayClassName={getDayClassName}
                        renderCustomHeader={({
                            date,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                            decreaseYear,
                            increaseYear
                        }) => (
                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', alignItems: 'center' }}>
                                <div>
                                    <button type="button" onClick={decreaseYear} style={headerBtnStyle}>{"<<"}</button>
                                    <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={headerBtnStyle}>{"<"}</button>
                                </div>
                                <span style={{ fontWeight: '600', fontSize: '14px' }}>
                                    {date.toLocaleString('default', { month: 'short' })} {date.getFullYear()}
                                </span>
                                <div>
                                    <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={headerBtnStyle}>{">"}</button>
                                    <button type="button" onClick={increaseYear} style={headerBtnStyle}>{">>"}</button>
                                </div>
                            </div>
                        )}
                    >
                        {formData.date === todayStr && (
                            <div style={{ borderTop: '1px solid #eee', textAlign: 'center', padding: '10px' }}>
                                <button
                                    type="button"
                                    style={{ color: '#F07167', background: 'none', border: 'none', fontWeight: 'bold', cursor: 'pointer' }}
                                    onClick={() => onDateChange(new Date())}
                                >
                                    Today
                                </button>
                            </div>
                        )}
                    </DatePicker>
                </div>

                <div className="booking-schedule-col" style={{ flex: 2, minWidth: '300px' }}>
                    <label style={styles.label}>
                        {formData.date ? `Available Time Slots for ${getDayName(formData.date)}` : "Select a date to see slots"}
                    </label>

                    {loadingSlots ? (
                        <p style={{ fontSize: '13px', color: '#666' }}>Loading available slots...</p>
                    ) : (
                        <>
                            {availableSlots.length > 0 ? (
                                <div style={styles.timeSlots}>
                                    {availableSlots.map((slot, index) => {
                                        // Create display string like "2:00 PM - 3:00 PM"
                                        const displayTimeSlot = `${slot.from} - ${slot.to}`;
                                        const isSelected = formData.timeSlot === displayTimeSlot;
                                        const isSoon = slot.status === 'soon';

                                        return (
                                            <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <button
                                                    onClick={() => !isSoon && handleInput("timeSlot", displayTimeSlot)}
                                                    style={{
                                                        ...(isSelected ? styles.timePillActive : styles.timePill),
                                                        ...(isSoon ? { opacity: 0.6, cursor: 'not-allowed', borderColor: '#ccc' } : {})
                                                    }}
                                                    disabled={isSoon}
                                                >
                                                    <span style={{ marginRight: '5px' }}>🕒</span>
                                                    {displayTimeSlot}
                                                </button>
                                                {isSoon && (
                                                    <span style={{ fontSize: '10px', color: '#F07167', marginTop: '4px', fontWeight: 'bold' }}>
                                                        Booking closed
                                                    </span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <p style={{ fontSize: '13px', color: '#F07167' }}>{availabilityMessage || "Please select a date."}</p>
                            )}
                        </>
                    )}
                </div>
            </div>

            <div style={{ marginTop: '30px' }}>
                <label style={styles.label}>Add your message (Optional)</label>
                <textarea
                    style={styles.textArea}
                    placeholder="Enter your message"
                    value={formData.message}
                    onChange={e => handleInput("message", e.target.value)}
                />
                <p style={{ fontSize: '10px', color: '#888', marginTop: '5px' }}>0 of 300 characters left</p>
            </div>

            <div className="booking-button-row" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
                <button onClick={prevStep} style={styles.backBtn}>Go Back to Previous Step</button>
                <button
                    onClick={nextStep}
                    style={formData.date && formData.timeSlot ? styles.continueBtnActive : styles.continueBtn}
                    disabled={!formData.date || !formData.timeSlot}
                >
                    Continue
                </button>
            </div>
        </div>
    );
};
const PaymentForm = ({ formData, handleInput, prevStep, handleSubmitOrder, loading, price, packageType, finalPrice, discountAmount, promoCodeInput, setPromoCodeInput, promoStatus, promoErrorMsg, handleApplyPromo }) => {
    const [isCouponsOpen, setIsCouponsOpen] = useState(false);

    return (
    <div className="booking-card-content" style={styles.cardContent}>
        <div className="booking-payment-row" style={{ display: 'flex', gap: '40px' }}>
            <div className="booking-payment-col" style={{ flex: 1.8 }}>
                <div style={{ marginBottom: '30px' }}>
                    <h3 style={styles.subHead}>Customer Details <img src={ASSETS.icons.edit} width="14" alt="edit" style={{ marginLeft: '10px', cursor: 'pointer' }} /></h3>
                    <div style={styles.detailBox}>
                        <p style={styles.detailText}><strong>{formData.fullName || "User Name"}</strong></p>
                        <p style={styles.detailText}>{formData.email || "email@example.com"}</p>
                        <p style={styles.detailText}>+91 {formData.contactNumber || "9999999999"}</p>
                    </div>
                </div>

                <div style={{ marginBottom: '30px' }}>
                    <h3 style={styles.subHead}>Payment</h3>
                    <div className="booking-razorpay-box" style={styles.razorpayBox}>
                        <img src={ASSETS.icons.payment} alt="" style={{ height: '18px', opacity: 0.6 }} />
                        <span style={{ fontSize: '12px', marginLeft: '12px', color: '#444', lineHeight: '1.4' }}>After placing the order, you'll be redirected to <strong>Razorpay</strong> to complete the payment.</span>
                    </div>
                    <div style={{ marginTop: '12px' }}>
                        <img src={ASSETS.razorpay} alt="Razorpay" style={{ height: '22px' }} />
                    </div>
                </div>

                <div style={{ marginBottom: '30px' }}>
                    <h3 style={styles.subHead}>Billing Address</h3>
                    <div className="booking-form-row" style={styles.row}>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>First Name<span style={styles.red}>*</span></label>
                            <input style={styles.input} value={formData.billFirstName} onChange={e => handleInput("billFirstName", e.target.value)} />
                        </div>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Last Name<span style={styles.red}>*</span></label>
                            <input style={styles.input} value={formData.billLastName} onChange={e => handleInput("billLastName", e.target.value)} />
                        </div>
                    </div>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Phone Number<span style={styles.red}>*</span></label>
                        <div className="booking-phone-group" style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                            <select style={{ ...styles.select, width: '80px' }}><option>+91</option></select>
                            <input style={styles.input} value={formData.billPhone} onChange={e => handleInput("billPhone", e.target.value)} />
                        </div>
                    </div>
                    <div className="booking-form-row" style={styles.row}>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Country/Region<span style={styles.red}>*</span></label>
                            <select style={styles.select} value={formData.billCountry} onChange={e => handleInput("billCountry", e.target.value)}><option>India</option></select>
                        </div>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>Address<span style={styles.red}>*</span></label>
                            <input style={styles.input} value={formData.billAddress} onChange={e => handleInput("billAddress", e.target.value)} />
                        </div>
                        <div style={styles.inputGroup}>
                            <label style={styles.label}>City<span style={styles.red}>*</span></label>
                            <input style={styles.input} value={formData.billCity} onChange={e => handleInput("billCity", e.target.value)} />
                        </div>
                    </div>
                    <div className="booking-zip-group" style={{ width: '32%' }}>
                        <label style={styles.label}>Zip/Postal Code<span style={styles.red}>*</span></label>
                        <input style={styles.input} value={formData.billZip} onChange={e => handleInput("billZip", e.target.value)} />
                    </div>
                    {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '15px' }}>
                        <button style={styles.saveBtn}>Save Billing Address</button>
                    </div> */}
                </div>

                <div>
                    <h3 style={styles.subHead}>Review & Place Order</h3>
                    <p style={{ fontSize: '13px', color: '#666' }}>Review your details above and continue when you're ready.</p>
                </div>
            </div>

            <div className="booking-payment-col" style={{ flex: 1 }}>
                <div style={styles.summaryCard}>
                    <h3 style={{color:"#555555", fontSize: '16px', fontWeight: 'bold', borderBottom: '1px solid #eee', paddingBottom: '15px', marginBottom: '15px' }}>Order summary</h3>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '14px', fontWeight: '500', color: '#555' }}>
                        <span>{packageType || "Book a Session!"}</span>
                        <span>₹{price}</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#555', marginBottom: '15px', lineHeight: '1.6' }}>
                        {formData.date || "Date Not Selected"}, {formData.timeSlot || "Time"}
                        {/* <br /> <span style={{ color: '#F07167', cursor: 'pointer', fontWeight: '500', fontSize: '11px' }}>Show more ⌵</span> */}
                    </div>

                    <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                        {promoStatus === 'success' ? (
                            <>
                                <div style={{ padding: '10px', backgroundColor: '#FFE5D57', borderRadius: '8px', color: '#F07167', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <span><strong>{promoCodeInput.toUpperCase()}</strong> applied!</span>
                                    <span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => { setPromoCodeInput(''); handleApplyPromo({ reset: true }); }}>Remove</span>
                                </div>
                                <div style={{ marginTop: '12px', padding: '12px 15px', backgroundColor: '#FFE5D9', borderRadius: '8px', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                                    <span style={{ color: '#F07167', fontSize: '16px', lineHeight: '1' }}>✦</span>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#003049', lineHeight: '1.5', fontWeight: '500' }}>
                                        As promised your first session is free and then the rest remains the same and they don't get charged.
                                    </p>
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={{ marginBottom: '12px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                    <span style={{ fontSize: '12px', color: '#555', fontWeight: 'bold' }}>Try Coupons</span>
                                    <div style={{ border: '1px dashed #fff', borderRadius: '8px', overflow: 'hidden', backgroundColor: '#FFF7F1' }}>
                                        <div 
                                            onClick={() => setIsCouponsOpen(!isCouponsOpen)}
                                            style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'center', 
                                                padding: '8px 12px', 
                                                cursor: 'pointer' 
                                            }}
                                        >
                                            <span style={{ fontSize: '13px', color: '#999', fontWeight: 'bold' }}>Click to select a coupon...</span>
                                            <span style={{ transform: isCouponsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease', display: 'flex' }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <polyline points="6 9 12 15 18 9"></polyline>
                                                </svg>
                                            </span>
                                        </div>
                                        
                                        {isCouponsOpen && (
                                            <div style={{ backgroundColor: '#fff', borderTop: '1px dashed #eee' }}>
                                                <div 
                                                    style={{ padding: '10px 12px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', color: '#555', transition: 'background-color 0.2s' }}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#FFF7F1'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                    onClick={() => {
                                                        setPromoCodeInput('TRUSTFIRST'); 
                                                        handleApplyPromo({ reset: true });
                                                        setIsCouponsOpen(false);
                                                    }}
                                                >
                                                    TRUSTFIRST
                                                </div>
                                                {/* You can easily add more coupons here in the future! */}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <input
                                        style={{ flex: 1, padding: '10px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', outline: 'none' }}
                                        placeholder="Enter a promo code"
                                        value={promoCodeInput}
                                        onChange={(e) => { setPromoCodeInput(e.target.value); handleApplyPromo({ reset: true }); }}
                                        disabled={promoStatus === 'validating'}
                                    />
                                    <button
                                    onClick={() => handleApplyPromo({ reset: false })}
                                    disabled={!promoCodeInput.trim() || promoStatus === 'validating'}
                                    style={{ padding: '0 15px', backgroundColor: promoCodeInput.trim() ? '#003049' : '#ccc', color: '#fff', border: 'none', borderRadius: '8px', cursor: promoCodeInput.trim() ? 'pointer' : 'not-allowed', fontSize: '13px', fontWeight: 'bold' }}
                                >
                                    {promoStatus === 'validating' ? '...' : 'Apply'}
                                </button>
                            </div>
                            </>
                        )}
                        {promoStatus === 'error' && <div style={{ color: '#ff4444', fontSize: '11px', marginTop: '5px' }}>{promoErrorMsg}</div>}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '13px', color: '#444' }}><span>Subtotal</span><span>₹{price}.00</span></div>
                    {discountAmount > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '13px', color: '#003049' }}><span>Discount</span><span>-₹{discountAmount}.00</span></div>}
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '13px', color: '#444' }}><span>Taxes</span><span>₹0.00</span></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '16px', borderTop: '1px solid #eee', paddingTop: '15px', marginTop: '10px', color: '#003049' }}>
                        <span>Total</span><span>₹{finalPrice}.00</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="booking-button-row" style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', marginTop: '40px' }}>
            <button onClick={prevStep} style={styles.backBtn}>Go Back to Previous Step</button>
            <button onClick={handleSubmitOrder} style={styles.placeOrderBtn}>
                {loading ? "Processing..." : "Place Order & Pay"}
            </button>
        </div>
    </div>
    );
};

// --- MAIN COMPONENT ---

export default function BookingFlow({ therapist, packageType, sessionCount, price, onBack, user }) {
    const { setIsLoginOpen } = useOutletContext();
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [playVideo, setPlayVideo] = useState(false);
    const [internalView, setInternalView] = useState("form");
    const [showSuccess, setShowSuccess] = useState(false);

    // --- PROMO CODE STATE ---
    const [promoCodeInput, setPromoCodeInput] = useState("");
    const [promoStatus, setPromoStatus] = useState("idle"); // idle, validating, success, error
    const [promoErrorMsg, setPromoErrorMsg] = useState("");
    const [discountAmount, setDiscountAmount] = useState(0);
    const finalPrice = Math.max(0, price - discountAmount);

    const generateDeviceID = () => {
        const { userAgent, language, hardwareConcurrency } = navigator;
        const { width, height, colorDepth } = window.screen;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return btoa(`${userAgent}-${language}-${hardwareConcurrency}-${width}x${height}-${colorDepth}-${timezone}`);
    };

    const handleApplyPromo = async ({ reset = false }) => {
        if (reset) {
            setPromoStatus("idle");
            setPromoErrorMsg("");
            setDiscountAmount(0);
            return;
        }

        if (!promoCodeInput.trim()) return;
        setPromoStatus("validating");
        setPromoErrorMsg("");

        if (promoCodeInput.trim().toUpperCase() !== "TRUSTFIRST") {
            setPromoStatus("error");
            setPromoErrorMsg("Invalid Promo Code");
            return;
        }

        if (sessionCount > 1) {
            setPromoStatus("error");
            setPromoErrorMsg("Promo only valid for single sessions");
            return;
        }

        if (localStorage.getItem('used_trustfirst')) {
            setPromoStatus("error");
            setPromoErrorMsg("Invalid Promo Code");
            return;
        }

        const deviceID = generateDeviceID();
        try {
            const response = await fetch('https://us-central1-nabi-1708b.cloudfunctions.net/validatePromoCode', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    promoCode: promoCodeInput.trim().toUpperCase(),
                    phoneNumber: formData.contactNumber,
                    email: formData.email,
                    userId: user ? user.uid : null,
                    deviceID: deviceID
                })
            });
            const data = await response.json();
            
            if (data.success) {
                setPromoStatus("success");
                setDiscountAmount(price);
            } else {
                setPromoStatus("error");
                setPromoErrorMsg(data.error || "Invalid Promo Code");
            }
        } catch (err) {
            console.error("Promo validation error", err);
            setPromoStatus("error");
            setPromoErrorMsg("Error validating code. Try again.");
        }
    };

    const today = new Date();
    const initDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    const [formData, setFormData] = useState({
        fullName: "", age: "", gender: "", contactNumber: "", email: "", studentStatus: "Student",
        trustName: "", trustRelationship: "", trustContact: "",
        declaration1: false, declaration2: false, declaration3: false,
        termsAccepted: false,
        date: initDate, timeSlot: "", message: "",
        billFirstName: "", billLastName: "", billPhone: "",
        billCountry: "", billAddress: "", billCity: "", billZip: ""
    });
    const formatDate = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        const day = date.getDate();
        const year = date.getFullYear();
        const month = date.toLocaleString('en-US', { month: 'long' });

        const getOrdinal = (n) => {
            if (n > 3 && n < 21) return "th";
            switch (n % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        return `${day}${getOrdinal(day)} ${month} ${year}`;
    };

    const handleInput = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const nextStep = () => setStep(prev => prev + 1);
    const prevStep = () => setStep(prev => prev - 1);

    // --- PAYMENT LOGIC ---
    const createPendingBooking = async () => {
        try {
            const userId = auth.currentUser?.uid || "guest";
            const userName = auth.currentUser?.displayName || formData.fullName || "Customer";

            const payload = {
                userId,
                userName,
                therapistId: therapist?.id || "default_therapist_id",
                therapistName: therapist?.name || "default_therapist_name",
                therapistEmail: therapist?.email || "default_email@nabi.health",
                therapistImage: therapist?.image || "",
                packageType: packageType || "One Session Package",
                sessionCount: sessionCount,
                sessionsUsed: formData.date ? 1 : 0,
                price: finalPrice,
                appliedPromo: promoStatus === 'success' ? promoCodeInput.toUpperCase() : null,
                deviceID: promoStatus === 'success' ? generateDeviceID() : null,
                ...formData,
                status: "pending_verification",
                createdAt: serverTimestamp()
            };

            if (formData.date && formData.timeSlot) {
                payload.session_1 = {
                    date: formData.date,
                    time: formData.timeSlot
                };
            }

            const bookingRef = await addDoc(collection(db, "bookings"), payload);
            return bookingRef.id;
        } catch (error) {
            console.error("Error creating pending booking:", error);
            throw error;
        }
    };

    const handlePaymentSuccess = async (bookingId, paymentResponse) => {
        try {
            // Frontend updates the payment ID, but leaves status alone so Webhook can confirm it securely
            await updateDoc(doc(db, "bookings", bookingId), {
                status: "processing_payment", 
                paymentId: paymentResponse?.razorpay_payment_id || "manual_test_payment",
                paymentTime: new Date().toISOString(),
            });

            // --- AUDIT LOGGING ---
            try {
                await addDoc(collection(db, "booking_audit"), {
                    bookingId: bookingId,
                    action: "BOOKING_CREATED",
                    userId: auth.currentUser?.uid || "guest",
                    userEmail: formData.email,
                    therapistId: therapist?.id,
                    packageType: packageType || "One Session Package",
                    price: price,
                    status: "pending_to_confirmed",
                    timestamp: serverTimestamp()
                });

                await addDoc(collection(db, "payment_audit"), {
                    bookingId: bookingId,
                    paymentId: paymentResponse?.razorpay_payment_id || "manual_test_payment",
                    action: "PAYMENT_SUCCESS_FRONTEND",
                    amount: price,
                    status: "success",
                    timestamp: serverTimestamp()
                });
            } catch (auditError) {
                console.error("Failed to create audit logs:", auditError);
            }

            // Listen for backend confirmation of capture
            const unsubscribe = onSnapshot(doc(db, "bookings", bookingId), (docSnap) => {
                const data = docSnap.data();
                if (data && data.paymentStatus === "captured") {
                    setShowSuccess(true);
                    setLoading(false);
                    unsubscribe();
                }
            });

        } catch (error) {
            console.error("Error updating booking after payment:", error);
            alert("Payment successful, but booking save failed. Please contact support.");
            setLoading(false);
        }
    };

    const logPaymentFailure = async (errorDetails) => {
        try {
            await addDoc(collection(db, "payment_audit"), {
                userId: auth.currentUser?.uid || "guest",
                userEmail: formData.email,
                therapistId: therapist?.id,
                packageType: packageType || "One Session Package",
                amount: price,
                action: "PAYMENT_FAILED",
                status: "failed",
                error: errorDetails || "Payment modal dismissed or failed",
                timestamp: serverTimestamp()
            });
        } catch (auditError) {
            console.error("Failed to log payment failure:", auditError);
        }
    };

    const handleSubmitOrder = async () => {
        setLoading(true);
        try {
            const bookingId = await createPendingBooking();

            if (finalPrice === 0) {
                if (promoStatus === 'success' && promoCodeInput.toUpperCase() === 'TRUSTFIRST') {
                    localStorage.setItem('used_trustfirst', 'true');
                }
                
                await updateDoc(doc(db, "bookings", bookingId), {
                    status: "confirmed", 
                    paymentId: "promo_100_percent_free",
                    paymentTime: new Date().toISOString(),
                    paymentStatus: "captured"
                });

                await addDoc(collection(db, "payment_audit"), {
                    bookingId: bookingId,
                    paymentId: "promo_100_percent_free",
                    action: "PAYMENT_SUCCESS_FRONTEND",
                    amount: 0,
                    status: "success",
                    promoCode: promoCodeInput.toUpperCase(),
                    timestamp: serverTimestamp()
                });

                setShowSuccess(true);
                setLoading(false);
                return;
            }

            const response = await fetch('https://us-central1-nabi-1708b.cloudfunctions.net/createRazorpayOrder', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: finalPrice, bookingId, type: 'slot' })
            });
            const data = await response.json();
            
            if (!data.success) {
                throw new Error(data.error || "Failed to create Razorpay Order");
            }

            const orderId = data.order_id;

            processPayment({
                price: finalPrice,
                userData: formData,
                bookingId: bookingId,
                orderId: orderId,
                onSuccess: (response) => {
                    handlePaymentSuccess(bookingId, response);
                },
                onFailure: (error) => {
                    setLoading(false);
                    alert(" Payment Failed or Cancelled. If the amount was deducted, please contact support with your email ID.");
                    logPaymentFailure(error);
                    
                    // Mark pending booking as failed
                    updateDoc(doc(db, "bookings", bookingId), {
                        status: "payment_failed"
                    }).catch(err => console.error("Could not update failed booking status:", err));
                }
            });
        } catch (err) {
            setLoading(false);
            alert("Could not initialize payment. Please try again.");
        }
    };

    const renderStars = (rating) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            const isFilled = i <= Math.round(rating || 0);
            stars.push(
                <img key={i} src={isFilled ? ASSETS.icons.starFilled : ASSETS.icons.starUnfilled} alt="" style={{ width: '14px', marginRight: '2px' }} />
            );
        }
        return stars;
    };

    const Stepper = () => (
        <div className="booking-stepper-container" style={styles.stepperContainer}>
            <div className="booking-step-item" style={styles.stepItem}>
                {/* FIXED: Removed overlapping background image and fixed img width */}
                <div className="booking-step-icon" style={step > 1 ? styles.stepIconDone : (step === 1 ? styles.stepIconActive : styles.stepIconInactive)}>
                    {step > 1 ? (
                        <div style={{
                            width: '22px',
                            height: '22px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F07167" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                    ) : (
                        <img
                            src={ASSETS.icons.intake}
                            alt=""
                            style={{
                                width: '20px',
                                filter: step === 1 ? 'brightness(0) invert(1)' : ''
                            }}
                        />
                    )}
                </div>
                <span className="booking-step-text" style={step === 1 ? styles.stepTextActive : styles.stepText}>Intake Form</span>
            </div>
            <div className="booking-step-line" style={styles.stepLine}></div>
            <div className="booking-step-item" style={styles.stepItem}>
                <div className="booking-step-icon" style={step > 2 ? styles.stepIconDone : (step === 2 ? styles.stepIconActive : styles.stepIconInactive)}>
                    {step > 2 ? (
                        <div style={{
                            width: '22px',
                            height: '22px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F07167" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                    ) : (
                        <img
                            src={ASSETS.icons.schedule}
                            alt=""
                            style={{
                                width: '20px',
                                filter: step === 2 ? 'brightness(0) invert(1)' : ''
                            }}
                        />
                    )}
                </div>
                <span className="booking-step-text" style={step === 2 ? styles.stepTextActive : styles.stepText}>Schedule Booking</span>
            </div>
            <div className="booking-step-line" style={styles.stepLine}></div>
            <div className="booking-step-item" style={styles.stepItem}>
                <div className="booking-step-icon" style={step === 3 ? styles.stepIconActive : styles.stepIconInactive}>
                    <img
                        src={ASSETS.icons.payment}
                        alt=""
                        style={{
                            width: '20px',
                            filter: step === 3 ? 'brightness(0) invert(1)' : ''
                        }}
                    />
                </div>
                <span className="booking-step-text" style={step === 3 ? styles.stepTextActive : styles.stepText}>Payment</span>
            </div>
        </div>
    );

    // --- INTERNAL ROUTING ---
    if (internalView === "terms") {
        return <TermsPage onBack={() => setInternalView("form")} />;
    }
    if (internalView === "privacy") {
        return <PrivacyPage onBack={() => setInternalView("form")} />;
    }

    // --- SUCCESS MODAL OVERLAY ---
    const SuccessModal = () => (
        <AnimatePresence>
            {showSuccess && (
                <motion.div
                    className="therapist-modal-overlay"
                    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
                >
                    {/* <motion.div 
                        initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }}
                        style={{ backgroundColor: 'white', borderRadius: '24px', padding: '40px', maxWidth: '400px', width: '100%', textAlign: 'center', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }}
                    >
                        <div style={{ width: '80px', height: '80px', borderRadius: '50%', backgroundColor: '#E8F5E9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                        </div>
                        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#333', marginBottom: '10px', marginTop: 0 }}>Booking Confirmed!</h2>
                        <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.5', marginBottom: '25px' }}>
                            Your session with <strong>{therapist?.name}</strong> has been successfully booked.
                        </p>
                        
                        <div style={{ backgroundColor: '#F8F9FA', borderRadius: '12px', padding: '20px', marginBottom: '30px', textAlign: 'left' }}>
                            <div style={{ display: 'flex', marginBottom: '10px' }}>
                                <span style={{ width: '80px', color: '#888', fontSize: '13px' }}>Date:</span>
                                <span style={{ fontWeight: '600', color: '#333', fontSize: '14px' }}>{getDayName(formData.date)}, {formData.date}</span>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <span style={{ width: '80px', color: '#888', fontSize: '13px' }}>Time:</span>
                                <span style={{ fontWeight: '600', color: '#333', fontSize: '14px' }}>{formData.timeSlot}</span>
                            </div>
                        </div>

                        <button 
                            onClick={() => { setShowSuccess(false); onBack(); }}
                            style={{ width: '100%', padding: '16px', borderRadius: '12px', backgroundColor: '#F07167', color: 'white', border: 'none', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }}
                        >
                            Return to Dashboard
                        </button>
                    </motion.div> */}
                    <motion.div
                        className="therapist-modal-content"
                        initial={{ scale: 0.9, y: 20 }}
                        animate={{ scale: 1, y: 0 }}
                        style={{
                            width: '100%',
                            maxWidth: '420px',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            fontFamily: "'Syne', sans-serif",
                            boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                            backgroundColor: '#fff'
                        }}
                    >

                        {/* Top Header */}
                        <div style={{
                            backgroundColor: '#F5F5F5',
                            padding: '13px 29px 10px',
                            textAlign: 'left'
                        }}>
                            <h2 style={{
                                margin: 0,
                                fontSize: '16px',
                                fontWeight: '600',
                                color: '#2D2D2D'
                            }}>
                                Booking Confirmation
                            </h2>
                        </div>

                        {/* Gradient Body */}
                        <div style={{
                            background: 'linear-gradient(180deg, #E9B873 0%, #F28C6B 100%)',
                            padding: '11px 59px 60px',
                            textAlign: 'center'
                        }}>
                            <h5 style={{
                                fontSize: '17px',
                                fontWeight: '700',
                                color: '#003049',
                                marginBottom: '10px'
                            }}>
                                {((promoStatus === 'success' && promoCodeInput?.trim().toUpperCase() === 'TRUSTFIRST') || Number(finalPrice) === 0) 
                                    ? `Welcome , ${user?.displayName || formData.fullName} thank you for booking your session with us.Here is your complimentary first session ,  feel to explore your thoughts and emotions .`
                                    : `Thank you ${user?.displayName || formData.fullName} for booking your session with us.`}
                            </h5>
                            <p style={{
                                fontSize: '15px',
                                fontWeight: '500',  
                                color: '#2D2D2D',
                                marginBottom: '30px'
                            }}>
                                Please check your email for confirmation
                            </p>

                            {/* Doctor Card */}
                            <div style={{
                                position: 'relative',
                                backgroundColor: '#F5F5F5',
                                borderRadius: '16px',
                                // textAlign: "justify",
                                padding: '40px 65px 15px',
                                boxShadow: '0 6px 16px rgba(0,0,0,0.1)'
                            }}>

                                {/* Doctor Image */}
                                <div style={{
                                    position: 'absolute',
                                    top: '-35px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '70px',
                                    height: '70px',
                                    borderRadius: '50%',
                                    overflow: 'hidden',
                                    border: '4px solid white',
                                    backgroundColor: '#ddd'
                                }}>
                                    <img
                                        src={therapist?.image}
                                        alt="doctor"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                </div>

                                {/* Name */}
                                <h3 style={{
                                    // marginTop: '10px',
                                    marginBottom: '10px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#2D2D2D'
                                }}>
                                    Dr.{therapist?.name}
                                </h3>

                                {/* Details */}
                                <div style={{ fontSize: '14px', color: '#444' }}>


                                    <div style={{ marginBottom: '8px' }}>    Date :
                                        <span style={{ display: 'inline-block', fontWeight: '600' }}>
                                            {formatDate(formData.date)}
                                        </span>
                                    </div>

                                    <div style={{ marginBottom: '8px' }}>Session :
                                        <span style={{ display: 'inline-block', marginLeft: '10px', fontWeight: '600' }}>{formData.timeSlot}</span>

                                    </div>

                                </div>

                            </div>
                        </div>

                        {/* Bottom Bar */}
                        <div style={{
                            backgroundColor: '#EDEDED',
                            padding: '14px',
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={() => { setShowSuccess(false); onBack(); }}
                                style={{
                                    padding: '6px 14px',
                                    borderRadius: '6px',
                                    border: '1px solid #999',
                                    backgroundColor: '#F5F5F5',
                                    fontSize: '12px',
                                    cursor: 'pointer'
                                }}
                            >
                                Close Window
                            </button>
                        </div>

                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );

    return (
        <div className="booking-page" style={styles.page}>
            <style>{customCSS}</style>
            <SuccessModal />
            {/* HERO SECTION */}
            <div className="booking-hero" style={styles.hero}>
                <div className="booking-hero-content" style={styles.heroContent}>
                    
                    <h1 className="booking-hero-title" style={styles.heroTitle}>We'd love to help,</h1>
                    <p className="booking-hero-sub" style={styles.heroSub}>The following details will help us better understand who you are,<br />identify support contacts, and gain your consent.</p>
                </div>
            </div>

            {/* CONTENT CONTAINER */}
            <div className="booking-container" style={styles.container}>
                <div className="booking-header-row" style={styles.headerRow}>
                    <h2 className="booking-page-title" style={styles.pageTitle}>Schedule a Session with {therapist?.name}</h2>
                    <button onClick={() => setShowProfile(true)} className="booking-view-profile-btn" style={styles.viewProfileBtn}>
                        View Therapist Profile ↗
                    </button>
                </div>

                <div className="booking-card" style={styles.card}>
                    <div className="booking-stepper-wrapper" style={styles.stepperWrapper}>
                        <Stepper />
                    </div>

                    {step === 1 && (
                        <IntakeForm
                            formData={formData}
                            handleInput={handleInput}
                            nextStep={nextStep}
                            onBack={onBack}
                            onOpenTerms={() => setInternalView("terms")}
                            onOpenPrivacy={() => setInternalView("privacy")}
                            onAuthCheck={() => setIsLoginOpen(true)}
                        />
                    )}
                    {step === 2 && <ScheduleForm formData={formData} handleInput={handleInput} prevStep={prevStep} nextStep={nextStep} therapist={therapist} price={price} user={user} packageType={packageType} />}
                    {step === 3 && (
                        <PaymentForm 
                            formData={formData} 
                            handleInput={handleInput} 
                            prevStep={prevStep} 
                            handleSubmitOrder={handleSubmitOrder} 
                            loading={loading} 
                            price={price} 
                            packageType={packageType}
                            finalPrice={finalPrice}
                            discountAmount={discountAmount}
                            promoCodeInput={promoCodeInput}
                            setPromoCodeInput={setPromoCodeInput}
                            promoStatus={promoStatus}
                            promoErrorMsg={promoErrorMsg}
                            handleApplyPromo={handleApplyPromo}
                        />
                    )}
                </div>
            </div>

            {/* --- PROFILE MODAL --- */}
            <AnimatePresence>
                {showProfile && (
                    <motion.div className="therapist-modal-overlay" style={styles.modalOverlay} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                        <motion.div className="therapist-modal-content" style={styles.modalContent} initial={{ y: 50 }} animate={{ y: 0 }} exit={{ y: 50 }}>
                            <div style={styles.modalHeader}>
                                <h2 className="therapist-modal-heading" style={styles.modalHeading}>Profile Overview</h2>
                                <button onClick={() => setShowProfile(false)} style={styles.closeBtn}>
                                    <img src={ASSETS.icons.close} alt="Close" style={{ width: '24px' }} />
                                </button>
                            </div>
                            <div style={styles.topSection}>
                                <div className="therapist-about-container" style={styles.aboutContainer}>
                                    <div style={styles.aboutTextContent}>
                                        <h3 style={styles.sectionHeader}>About Me</h3>
                                        <p style={styles.aboutText}>Hi, I am {therapist?.name}. Located in {therapist?.location}. {therapist?.qual}.</p>
                                        {((therapist?.expertise || therapist?.specializations || therapist?.specialties || therapist?.tags) && (therapist?.expertise || therapist?.specializations || therapist?.specialties || therapist?.tags).length > 0) && (
                                          <>
                                            <h3 style={styles.sectionHeader}>Expertise In</h3>
                                            <div style={styles.tagCloud}>
                                                {(therapist?.expertise || therapist?.specializations || therapist?.specialties || therapist?.tags).map((t, i) => <span key={i} style={styles.tag}>{t}</span>)}
                                            </div>
                                          </>
                                        )}
                                    </div>
                                    <div className="therapist-video-wrapper" style={styles.videoWrapper}>
                                        {therapist?.introVideo ? (
                                            playVideo ? (
                                                <video
                                                    width="100%"
                                                    height="100%"
                                                    controls
                                                    autoPlay
                                                    src={therapist.introVideo}
                                                    style={{ borderRadius: "16px", objectFit: "cover" }}
                                                />
                                            ) : (
                                                <>
                                                    {therapist?.image ? (
                                                        <img src={therapist.image} style={styles.videoPlaceholder} alt="Video Thumbnail" />
                                                    ) : (
                                                        <div style={{ ...styles.videoPlaceholder, display: 'flex', alignItems: 'center', justifyContent: 'center', background: "linear-gradient(180deg, #FFE1C5 20.91%, #FF8A67 198.29%)", color: '#C57B57', fontSize: '80px', fontWeight: 'bold', fontFamily: "'Syne', sans-serif" }}>
                                                            {getInitials(therapist?.name)}
                                                        </div>
                                                    )}
                                                    <div style={styles.playOverlay} onClick={() => setPlayVideo(true)}>
                                                        <img src={ASSETS.playIcon} alt="Play" style={{ width: '64px', cursor: 'pointer' }} />
                                                    </div>
                                                </>
                                            )
                                        ) : (
                                            therapist?.image ? (
                                                <img src={therapist.image} style={styles.videoPlaceholder} alt="Therapist Profile" />
                                            ) : (
                                                <div style={{ ...styles.videoPlaceholder, display: 'flex', alignItems: 'center', justifyContent: 'center', background: "linear-gradient(180deg, #FFE1C5 20.91%, #FF8A67 198.29%)", color: '#C57B57', fontSize: '80px', fontWeight: 'bold', fontFamily: "'Syne', sans-serif" }}>
                                                    {getInitials(therapist?.name)}
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

const styles = {
    page: { backgroundColor: "#FFF7F1", minHeight: "100vh", paddingBottom: '80px', fontFamily: "'Syne', sans-serif" },
    hero: {
        height: "280px",
        backgroundImage: `url('${ASSETS.hero}')`,
        backgroundSize: "cover",
        opacity: "1",
        backgroundColor: "black",
        backgroundPosition: "center",
        display: 'flex',
        // alignItems: 'right',
        paddingLeft: '8%',

        justifyContent:'center',
        paddingTop: '35px',
    },
    heroContent: { color: 'white', height: "90px" },
    breadcrumb: { fontSize: '12px', opacity: 0.9, marginBottom: '15px', fontWeight: "normal" },
    heroTitle: { fontSize: '2.5rem', fontWeight: '500', marginBottom: '10px' },
    heroSub: { fontSize: '1rem', opacity: 0.9, lineHeight: '1.5', fontWeight: '300' },

    container: { maxWidth: '1150px', margin: '40px auto 0', padding: '0 20px', position: 'relative', zIndex: 10 },
    headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', color: '#111', padding: '0 10px' },
    pageTitle: { fontSize: '1.8rem', fontWeight: 'normal', margin: 0 },
    viewProfileBtn: { background: 'transparent', border: 'none', cursor: 'pointer', fontWeight: 'normal', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '5px' },

    card: { backgroundColor: 'white', borderRadius: '30px', boxShadow: '0 10px 30px rgba(0,0,0,0.2)', padding: '0', overflow: 'hidden', minHeight: '600px' },
    stepperWrapper: { padding: '25px 60px', backgroundColor: '#FFDCC9', margin: '25px 25px 0', borderRadius: '50px' },
    stepperContainer: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    stepItem: { display: 'flex', alignItems: 'center', gap: '10px' },
    stepIconActive: { width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#F07167', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    stepIconInactive: { width: '32px', height: '32px', borderRadius: '50%', border: '1px solid #F07167', backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    // FIXED STYLE: Removed backgroundImage and backgroundColor to avoid overlapping/ghosting
    stepIconDone: { width: '32px', height: '32px', borderRadius: '50%', background:'linear-gradient(153.63deg, #FB5121 6.42%, #FB9621 84.22%)', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    stepText: { color: '#555', fontWeight: '40', fontSize: '16px', fontFamily: "'Syne', sans-serif" },
    stepTextActive: { color: '#003049', fontWeight: '100', fontSize: '16px' },
    stepLine: { flex: 1, height: '1px', backgroundColor: '#F07167', margin: '0 20px', opacity: 0.5 },

    cardContent: { padding: '40px 60px 60px' },
    formNote: { fontSize: '16px', color: '#555', marginBottom: '40px' },
    row: { display: 'flex', gap: '20px', marginBottom: '18px' },
    inputGroup: { flex: 1 },
    label: { display: 'block', fontSize: '13px', fontWeight: 'normal', marginBottom: '8px', color: '#222' },
    red: { color: '#F07167' },
    input: { width: '90%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #E0E0E0', fontSize: '14px', outline: 'none', color: '#333', fontFamily: "'Syne', sans-serif", fontWeight: "40" },
    select: { width: '90%', padding: '10px 12px', borderRadius: '8px', border: '1px solid #E0E0E0', fontSize: '14px', outline: 'none', backgroundColor: 'white', color: '#333', cursor: 'pointer' },
    checkboxGroup: { display: 'flex', flexDirection: 'column', gap: '12px' },
    checkLabel: { fontSize: '13px', color: '#444', display: 'flex', gap: '10px', alignItems: 'center', cursor: 'pointer' },
    continueBtn: { padding: '12px 30px', backgroundColor: '#F2F2F2', color: '#999', border: 'none', borderRadius: '8px', fontWeight: 'normal', cursor: 'not-allowed', transition: '0.3s' },
    continueBtnActive: { padding: '12px 30px', backgroundColor: '#24272f', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'normal', cursor: 'pointer', transition: '0.3s' },
    backBtn: { padding: '12px 25px', backgroundColor: 'white', border: '1px solid #333', borderRadius: '8px', fontWeight: 'normal', cursor: 'pointer', fontSize: '13px' },
    placeOrderBtn: { padding: '12px 35px', backgroundColor: '#24272f', color: 'white', border: 'none', borderRadius: '8px', fontWeight: 'normal', cursor: 'pointer' },
    saveBtn: { padding: '10px 20px', backgroundColor: 'white', border: '1px solid #ccc', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', fontWeight: '500' },

    bookingDetailsHeader: { display: 'flex', justifyContent: 'space-between', padding: '15px 0', borderBottom: '1px solid #eee', cursor: 'pointer', fontWeight: "normal" },
    bookingSummaryRow: { borderTop: '1px solid #f5f5f5', padding: '15px 0', fontSize: '12px', color: '#555', display: 'flex', alignItems: 'center', flexWrap: 'wrap' },
    summaryItem: { marginRight: '5px' },
    pipe: { margin: '0 10px', color: '#ccc' },
    badgeDark: { backgroundColor: '#333', color: 'white', fontSize: '10px', padding: '4px 10px', borderRadius: '12px', marginLeft: '10px' },
    dateInput: {
        width: '100%',
        padding: '12px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        fontSize: '14px',
        fontFamily: "'Syne', sans-serif",
        outline: 'none',
        backgroundColor: '#fff'
    },
    // dateInput: { width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', fontFamily: "'Syne', sans-serif", fontWeight: "40" },
    timeSlots: { display: 'flex', gap: '12px', flexWrap: 'wrap', fontFamily: "'Syne', sans-serif", fontWeight: "40" },
    timePill: { padding: '10px 20px', border: '1px solid #E0E0E0', borderRadius: '30px', background: 'white', cursor: 'pointer', fontSize: '12px', color: '#555' },
    timePillActive: { padding: '10px 20px', border: '1px solid #003049', borderRadius: '30px', background: 'white', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', color: '#003049' },
    textArea: { width: '100%', padding: '15px', border: '1px solid #ddd', borderRadius: '12px', minHeight: '120px', marginTop: '8px', fontSize: '14px', outline: 'none', fontFamily: "'Syne', sans-serif", fontWeight: "40" },

    subHead: { fontSize: '16px', fontWeight: 'normal', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' },
    detailBox: { fontSize: '14px', marginBottom: '10px' },
    detailText: { margin: '5px 0', color: '#333' },
    razorpayBox: { backgroundColor: '#FFDBC8', padding: '15px 20px', borderRadius: '8px', display: 'flex', alignItems: 'center', fontFamily: "'Syne', sans-serif", fontWeight: "40" },
    summaryCard: { border: '1px solid #E0E0E0', borderRadius: '16px', padding: '25px', backgroundColor: '#FFDCC9' },
    promoBox: { border: '1px dashed #aaa', padding: '12px', borderRadius: '8px', fontSize: '13px', color: '#555', margin: '20px 0', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' },
    summaryRow: { display: 'flex', justifyContent: 'space-between', marginBottom: '12px', fontSize: '14px', color: '#333' },

    modalOverlay: { position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" },
    modalContent: { backgroundColor: "white", width: "95%", maxWidth: "1200px", padding: "40px", borderRadius: "24px", position: "relative" },
    modalHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', borderBottom: '1px solid #E5E7EB', paddingBottom: '20px' },
    modalHeading: { fontSize: '1.8rem', fontWeight: 'normal', margin: 0, color: '#000' },
    closeBtn: { border: 'none', background: 'transparent', cursor: 'pointer', padding: 0 },
    topSection: { marginBottom: '0' },
    aboutContainer: { display: 'flex', gap: 0, border: '1px solid #E5E7EB', borderRadius: '20px', overflow: 'hidden' },
    aboutTextContent: { flex: 1.2, backgroundColor: '#FFF7F1', padding: '30px' },
    videoWrapper: { flex: 1, borderRadius: '0', overflow: 'hidden', height: 'auto', minHeight: '300px', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#003049' },
    videoPlaceholder: { width: '100%', height: '100%', objectFit: 'cover', opacity: 0.8 },
    playOverlay: { position: 'absolute', zIndex: 10 },
    sectionHeader: { fontSize: '1.4rem', fontWeight: '500', marginBottom: '16px', marginTop: '24px', color: '#111', fontFamily: "'Syne', sans-serif" },
    aboutText: { fontSize: '1rem', lineHeight: '1.6', color: '#222', marginBottom: '24px', fontFamily: "'Syne', sans-serif", fontWeight: '400' },
    tagCloud: { display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '16px' },
    tag: { padding: '8px 18px', background: 'white', borderRadius: '25px', border: '1px solid #CBD5E1', fontSize: '0.9rem', color: '#111', fontWeight: '500', fontFamily: "'Syne', sans-serif" },
};